import axios from 'axios';
import { ladeToken, loescheAuth } from 'core/features/auth/authApi';

/**
 * Axios-Client fuer die Identitaeten-API (`/api/identitaeten`). nginx leitet
 * `/api/*` an den api-service weiter. Alle Endpunkte sind nutzerbezogen und per
 * JWT geschuetzt; uebertragen werden ausschliesslich verschluesselte Daten
 * (Zero-Knowledge).
 */
const identitaetenApi = axios.create({
  baseURL: '/api/identitaeten',
  timeout: 30000,
});

identitaetenApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

identitaetenApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      loescheAuth();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const data = (response) => response.data;

export const fetchIdentitaetenApi = () => identitaetenApi.get('').then(data);
export const createIdentitaetApi = (dto) => identitaetenApi.post('', dto).then(data);
export const updateIdentitaetApi = (uuid, dto) => identitaetenApi.put(`/${uuid}`, dto).then(data);
export const deleteIdentitaetApi = (uuid) => identitaetenApi.delete(`/${uuid}`).then(() => uuid);

export default identitaetenApi;
